import React from 'react';
import PropTypes from 'prop-types';

export default function PepIcon(props) {
  const { fill, size } = props;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 20 20'>
      <path
        fill={fill}
        d='M16.636 1.004h-2.407v17.312h2.407a1.126 1.126 0 0 0 1.126-1.122V15.81h.666a1.044 1.044 0 1 0 0-2.084h-.666v-3.02h.666a1.044 1.044 0 1 0 0-2.087h-.666V5.594h.666a1.044 1.044 0 1 0 0-2.087h-.666V2.123A1.123 1.123 0 0 0 16.636 1Zm-1.173 13.762a1.539 1.539 0 0 1 1.536-1.536h.5v.493h-.437a1.044 1.044 0 1 0 0 2.084h.431v.5h-.5a1.536 1.536 0 0 1-1.536-1.539Zm0-5.107a1.536 1.536 0 0 1 1.536-1.533h.5v.49h-.437a1.044 1.044 0 1 0 0 2.087h.431v.491h-.5a1.539 1.539 0 0 1-1.536-1.536Zm1.536-6.638h.5v.49h-.437a1.044 1.044 0 1 0 0 2.087h.431v.49h-.5a1.5335 1.5335 0 1 1 0-3.067ZM1.569 1.262h1.173a.879.879 0 0 0-.158.51v2.806H1.558a.566.566 0 0 1-.557-.586V1.817a.563.563 0 0 1 .557-.554Zm.267 3.671h.736v3.3h-.736a.566.566 0 0 1-.566-.566V5.494a.566.566 0 0 1 .56-.563Zm.5 3.879h.237v3.3h-.237c-.311 0-.709-.252-.709-.563V9.374c-.006-.314.393-.566.7-.566Zm.712-6.684v15.056c0 .622.331 1.126.95 1.126h9.713V1.004H3.992c-.619 0-.95.5-.95 1.123Zm.991 5.949h2.773V5.35h3.166v2.727h2.683v3.166H9.972v2.718h-3.17v-2.727H4.029Z'
        data-name='Caminho 12246'
      />
      <path fill='none' d='M0 0h20v20H0z' data-name='Retângulo 148050' />
    </svg>
  );
}

PepIcon.defaultProps = {
  size: '20',
  fill: '#4b4b4b'
};

PepIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string
};
